import Container from '@material-ui/core/Container'
import TempAuthMessage from 'lib/ui/TempAuthMessage'
import AppBar from 'organization/user/Layout/AppBar'
import React from 'react'

export default function Layout(props: {children: React.ReactElement}) {
  return (
    <>
      <TempAuthMessage />
      <AppBar />
      <Container maxWidth={false}>{props.children}</Container>
    </>
  )
}
